import EzController from 'controllers/ez-base-controller';
import {
  triggerCustomEvent,
  splitTestEnabled,
  featureEnabled,
} from 'lib/helpers'; // split-test: resource_show_modal_view
import { getAjaxModal, ajaxPost } from 'lib/ajax-helpers'; // split-test: resource_show_modal_view

import events from 'lib/events'; // split-test: resource_show_modal_view

require('intersection-observer');

export default class ResourcesGridController extends EzController {
  gridObserver = null;

  connect() {
    this.initGrid();

    window.addEventListener('InitAllGrids', this.initGrid);
    window.addEventListener('TruncateGridTitles', this.truncateTitles);
    window.addEventListener('ReinitLazyGrid', this.reInitLazyGrid);

    if (this.element.parentNode.classList.contains('ez-search-results')) {
      this.insertSearchDeboostingButtons();
    }
  }

  disconnect() {
    window.removeEventListener('InitAllGrids', this.initGrid);
    window.removeEventListener('TruncateGridTitles', this.truncateTitles);
    window.removeEventListener('ReinitLazyGrid', this.reInitLazyGrid);

    if (this.gridObserver) this.gridObserver.disconnect();
  }

  remove = () => {
    this.element.remove();
  }

  initGrid = () => {
    if (this.element.classList.contains('ez-resource-grid--partner')) return;

    if (!this.element.dataset.instantGrid) {
      window.ezResourceGrid(this.element, {
        rowHeight: parseInt(this.element.getAttribute('data-row-height'), 10),
        maxRows: parseInt(this.element.getAttribute('data-max-rows'), 10),
        truncate: !!this.element.getAttribute('data-truncate-results'),
      });
    }

    const gridItems = this.element.querySelectorAll('.ez-resource-grid__item');
    gridItems.forEach((item, index) => {
      item.setAttribute('data-position', index + 1);
    });

    if (this.data.get('lazy') === 'true') {
      this.loadLazy(this.element.getAttribute('data-lazy-offset'));
    }
  }

  reInitLazyGrid = (event) => {
    if (this.element === event.detail.element) {
      this.loadLazy(this.element.getAttribute('data-lazy-offset'));
    }
  }

  // start split-test: resource_show_modal_view
  // can remove check for split test and else path
  // if split test wins
  loadShowPage = (event) => {
    if (splitTestEnabled('show-page-modal-view')) {
      event.preventDefault();

      const resourceShowUrl = event.currentTarget.getAttribute('href');

      getAjaxModal(resourceShowUrl);

      triggerCustomEvent(events.show_page.modal.build_resource_navigation_context, {
        targetResourcePath: resourceShowUrl,
        targetResourceGroup: event.currentTarget.closest('[data-controller="resources-grid"]'),
      });
    }
  }
  // end split-test: resource_show_modal_view

  loadLazy(lazyLoadOffset) {
    const lazyImages = [].slice.call(this.element.querySelectorAll('.ez-resource-thumb__img'));

    if ('IntersectionObserver' in window) {
      this.gridObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const lazyImage = entry.target;
            if (lazyImage.dataset.lazySrc) lazyImage.src = lazyImage.dataset.lazySrc;
            if (lazyImage.dataset.lazySrcset) lazyImage.srcset = lazyImage.dataset.lazySrcset;
            this.gridObserver.unobserve(lazyImage);
          }
        });
      }, { rootMargin: `0px 0px ${lazyLoadOffset}px 0px` });

      lazyImages.forEach((lazyImage) => {
        if (!lazyImage.classList.contains('lazy-observer')) {
          this.gridObserver.observe(lazyImage);
          lazyImage.classList.add('lazy-observer');
        }
      });
    } else { // We should not get here as we use polyfill
      console.error('Intersection observer not supported'); // eslint-disable-line no-console
    }
  }

  // quick and dirty for Shawn, refactor me
  insertSearchDeboostingButtons() {
    if (this.showDeboost) {
      const allResultsGridItems = document.querySelectorAll('.ez-search-results .ez-resource-thumb__link');
      allResultsGridItems.forEach((item) => {
        const nopeButton = document.createElement('DIV');

        nopeButton.classList.add('ez-resource-thumb__link__admin');
        nopeButton.classList.add('ez-resource-thumb__link__admin--nope');
        nopeButton.dataset.action = 'click->resources-grid#nopeResource';

        item.appendChild(nopeButton);
      });

      const grid = document.querySelectorAll('.ez-resource-grid')[0];
      const termButton = document.createElement('a');
      const termLink = document.createTextNode('exclude term');
      termButton.appendChild(termLink);
      termButton.dataset.action = 'click->resources-grid#excludeTerm';
      termButton.href = '#';
      grid.appendChild(termButton);
    }
  }

  get showDeboost() {
    return document.body.classList.contains('is-admin')
    && document.body.classList.contains('searches-show')
    && featureEnabled('search-deboost')
    && this.contentType !== 'vector';
  }

  nopeResource = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const ajaxUrl = '/admin/search/search_term_options/exclude';
    ajaxPost(ajaxUrl, this.afterSearchTweak, () => {}, this.stoParams(this.parseResourceId(event)));
  }

  excludeTerm = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    // eslint-disable-next-line no-alert
    const excluded = prompt('enter term to exclude');

    const params = {
      term: this.searchTerm,
      locale: this.locale,
      content_type: this.contentType,
      excluded_term: excluded,
    };
    const ajaxUrl = '/admin/search/search_term_options/exclude_term';
    ajaxPost(ajaxUrl, this.afterSearchTweak, () => {}, params);
  }

  stoParams = (resourceId) => ({
    term: this.searchTerm,
    locale: this.locale,
    content_type: this.contentType,
    resource_id: resourceId,
  })

  afterSearchTweak = () => {
    window.EezyScrollPositionHelper.preservePositionOnce();
    Turbolinks.visit(window.location);
  }

  get searchTerm() {
    const searchInfo = document.querySelector('[data-search-term]');
    if (searchInfo) {
      return searchInfo.getAttribute('data-search-term');
    }

    return '';
  }

  get locale() {
    return document.documentElement.getAttribute('lang');
  }

  get contentType() {
    return document.querySelector('#search').getAttribute('data-content-type');
  }

  parseResourceId(event) {
    const resourceId = event.target.parentNode.parentNode.dataset.itemId;
    return resourceId;
  }
}
